import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {GridComponent} from 'gelios-ng-admin-components';
import {AgGridEvent} from 'ag-grid-community';

@Component({
  selector: 'app-gelios-grid-column-row-selection-field',
  templateUrl: './gelios-grid-column-row-selection-field.component.html',
})
export class GeliosGridColumnRowSelectionFieldComponent extends GeliosFieldBaseComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  private selectionListener: any;
  private grid: GridComponent;

  constructor(
    protected translate: TranslateService,
  ) {
    super(translate);
  }

  ngOnInit() {
    super.ngOnInit();

    const config = this.reflexiveField.gridSelectionConfig;
    this.grid = config.grid;

    const init = (event: AgGridEvent) => {
      this.initializeSelection(event);
      this.setupSelection(event);
    };

    if (this.grid.gridApi && this.grid.gridColumnApi) {
      init({
        api: this.grid.gridApi,
        columnApi: this.grid.gridColumnApi
      } as AgGridEvent);
    } else {
      this.subscriptions.push(
        this.grid.gridReady.subscribe(init)
      );
    }
  }

  private setupSelection(e: AgGridEvent) {
    const api = e.api;

    if (this.selectionListener) {
      api.removeEventListener('selectionChanged', this.selectionListener);
    }

    this.selectionListener = () => {
      const valueField = this.reflexiveField.gridSelectionConfig.valueField || 'id';

      const value = api.getSelectedRows().map(r => r[valueField]);
      this.formGroup.controls[this.fieldName].setValue(value);
    };

    api.addEventListener('selectionChanged', this.selectionListener);
  }

  count(): number {
    const value = this.formGroup.controls[this.fieldName].value;
    return Array.isArray(value) ? value.length : 0;
  }

  private initializeSelection(e: AgGridEvent) {
    const columnApi = e.columnApi;

    const config = this.reflexiveField.gridSelectionConfig;
    columnApi.setColumnVisible(config.columnFieldName, true);
    setTimeout(() => this.grid.setMultipleSelection());

    e.api.deselectAll();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());

    const config = this.reflexiveField.gridSelectionConfig;
    const grid = config.grid;
    setTimeout(() => this.grid.setSingleSelection());

    if (this.selectionListener && grid.gridApi) {
      grid.gridApi.removeEventListener('selectionChanged', this.selectionListener);
    }

    if (grid.gridApi) {
      grid.gridApi.deselectAll();
    }

    this.formGroup.controls[this.fieldName].setValue([]);

    if (grid.gridColumnApi) {
      grid.gridColumnApi.setColumnVisible(config.columnFieldName, false);
    }
  }
}
